import FacultyTable from './FacultyTable';

const NonTeachingStaff = ({ faculty }) => (
  <FacultyTable
    faculty={faculty}
    isTeaching={false}
    title="Non Teaching"
  />
);

export default NonTeachingStaff;
